<template>
  <div class="menu">
    <div class="logo">
      <span class="iconfont">&#xe69c;</span>
      <img src="@/assets/img/portal.png" alt="">
    </div>
    <ul>
      <li :class="selected == 'home' ? 'active' : ''">
        <span class="iconfont">&#xe6c3;</span>
        <em>首页</em>
      </li>
      <li :class="selected == 'file' ? 'active' : ''">
        <Spot v-if="type && route.name != 'file'" @click="toPath('file')">
          <span class="iconfont">&#xe6db;</span>
          <em>文件签署</em>
        </Spot>
        <template v-else>
          <span class="iconfont">&#xe6db;</span>
          <em>文件签署</em>
        </template>
      </li>
      <li :class="selected == 'seal' ? 'active' : ''">
        <span class="iconfont">&#xe6c6;</span>
        <em>印章/签字</em>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { ref, defineProps, computed } from 'vue';
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const props = defineProps({
  selected: {
    type: Array,
    default: ['1'],
  },
});
const type = route.query.type;
const toPath = (name) => {
  router.push({
    name: name,
    query: {
      type: type
    }
  });
}
</script>
<style lang="less" scoped>
.menu {
  width: 120px;
  height: 100%;
  background: #f1f6ff;
  text-align: center;
  overflow: hidden;
  .logo {
    margin: 20px 0 55px;
    span {
      font-size: 40px;
    }
  }
  ul {
    padding: 0;
    li {
      height: 80px;
      width: 120px;
      padding-top: 12px;
      color: #7d92c9;
      cursor: pointer;
      span {
        display: block;
        font-size: 24px;
      }
      em {
        display: block;
        font-style: normal;
        font-size: 14px;
        line-height: 20px;
      }
    }
    li.active {
      background: #ffffff;
      color: @primaryColor;
      position: relative;
    }
    li.active::after {
      content: "";
      width: 3px;
      height: 80px;
      position: absolute;
      left: 0;
      top: 0;
      background: @primaryColor;
    }
  }
}
</style>